import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { ReportGenerationOptions } from "../types";

interface ReportConfigurationProps {
  reportOptions: ReportGenerationOptions;
  onOptionChange: (option: keyof ReportGenerationOptions, value: any) => void;
}

export const ReportConfiguration: React.FC<ReportConfigurationProps> = ({
  reportOptions,
  onOptionChange,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-medium">Report Contents</h3>
      
      <div className="flex items-center space-x-2">
        <Checkbox
          id="nav-summary"
          checked={reportOptions.includeNAVSummary}
          onCheckedChange={(checked) =>
            onOptionChange("includeNAVSummary", !!checked)
          }
        />
        <Label htmlFor="nav-summary">Include NAV Summary</Label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="holdings"
          checked={reportOptions.includeHoldings}
          onCheckedChange={(checked) =>
            onOptionChange("includeHoldings", !!checked)
          }
        />
        <Label htmlFor="holdings">Include Holdings Detail</Label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="performance"
          checked={reportOptions.includePerformance}
          onCheckedChange={(checked) =>
            onOptionChange("includePerformance", !!checked)
          }
        />
        <Label htmlFor="performance">Include Performance Data</Label>
      </div>
    </div>
  );
}; 